import { LintError } from './LintError'

/**
 * 检查警告，可以被修复
 */
export abstract class LintWarning extends LintError {}
